import { INCLUSO_EMAIL, INCLUSO_PHONE } from "~/content/value";
import TextLink from "../textLink";
import { ExclamationCircleIcon } from "@heroicons/react/20/solid";

export enum ErrorMessageType {
  SERVER_ERROR = "Server Error",
  NOT_FOUND = "404 Not Found",
  UNKNOWN = "Unknown",
}

const ErrorMessageStatus = (props: {
  errorMessage: string;
  type?: ErrorMessageType;
  className?: string;
}) => {
  const { errorMessage, type = ErrorMessageType.SERVER_ERROR } = props;
  return (
    <div
      className={`flex w-full flex-col items-center gap-2 text-red-600 ${props.className}`}
    >
      <ExclamationCircleIcon className="size-8 fill-red-600" />
      <p className={``}>{errorMessage}</p>
      <p className={`mt-2`}>
        Please try again later, or contact us directly via email{" "}
        <TextLink mail underline href={INCLUSO_EMAIL} text={INCLUSO_EMAIL} /> or
        phone{" "}
        <TextLink tel underline href={INCLUSO_PHONE} text={INCLUSO_PHONE} />.
      </p>
    </div>
  );
};

export default ErrorMessageStatus;
